/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import {
  useCommunicationAction,
  useCommunicationSelect,
} from 'src/hooks/useCommunication'
import { useAccountSelect } from 'src/hooks/useAccount'
import Button from '@mui/material/Button'
import { useRouterObjectPage } from 'src/hooks/router/useRouterObjectPage'
import { useSearchQuery } from 'src/hooks/useSearchQuery'
import { ICall } from 'src/store/modules/communication/types'
import UserIcon from 'src/layouts/components/UserIcon'
import { IconButton } from '@mui/material'
import { useContactScheme } from 'src/hooks/useContactScheme'

export const RingCentralIncomingCall = () => {
  const user = useAccountSelect.user()
  const getActiveCalls = useCommunicationAction.getActiveCalls()
  const getActiveCallsStatus = useCommunicationAction.getActiveCalls.status()

  const activeCalls = useCommunicationSelect.activeCalls()
  const [firstActiveCall] = activeCalls

  React.useEffect(() => {
    if (!user?.id) return

    getActiveCalls({
      assignedUserId: user.id as number,
      accountDriver: 'ring-central',
    })
  }, [user?.id])

  const isShow = activeCalls.length > 0

  if (!isShow) return <></>

  return (
    <Stack
      spacing={2}
      direction={'row'}
      sx={{
        '&:hover .rc-incoming-calls-popever': {
          zIndex: 1000,
          opacity: 1,
        },
      }}
    >
      <Stack
        height={76}
        position={'relative'}
        sx={{
          width: '380px',
        }}
      >
        {firstActiveCall && (
          <IncomingCallCard
            key={firstActiveCall.id}
            activeCall={firstActiveCall}
          />
        )}
        <Stack
          className="rc-incoming-calls-popever"
          sx={{
            position: 'absolute',
            top: 0,
            lef: 0,
            width: '100%',

            opacity: 0,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <Stack
            sx={{
              maxHeight: '325px',
              overflowY: 'scroll',
            }}
          >
            <Paper
              elevation={12}
              sx={{
                width: '100%',
              }}
            >
              <Stack spacing={2}>
                {activeCalls.map((activeCall) => (
                  <IncomingCallCard
                    key={activeCall.id}
                    activeCall={activeCall}
                  />
                ))}
              </Stack>
            </Paper>
          </Stack>
        </Stack>
      </Stack>
      {activeCalls.length > 1 && (
        <Stack
          color={'info.main'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Typography
            color="info.light"
            variant="subtitle2"
            fontWeight={'bolder'}
          >
            {activeCalls.length} Calls
          </Typography>
          <Stack spacing={1} direction={'row'}>
            <UserIcon icon="material-symbols:call-outline"></UserIcon>
            <UserIcon icon="material-symbols:arrow-drop-down-rounded"></UserIcon>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
}

interface IIncomingCallCardProps {
  activeCall: ICall
}
export const IncomingCallCard = (props: IIncomingCallCardProps) => {
  const { activeCall } = props
  const { setPathQuery } = useSearchQuery()
  const routeObjectPage = useRouterObjectPage()
  const setActiveCallsClose = useCommunicationAction.setActiveCallsClose()

  const handleOpenDetails = () => {
    if (!activeCall?.subscriber?.storageObject) return
    const { storageObject } = activeCall?.subscriber
    const {
      uniqId,
      objectSchemeIdentifier,
      parentObjectUniqId,
      parentObjectSchemeIdentifier,
    } = storageObject

    if (parentObjectSchemeIdentifier && parentObjectUniqId) {
      routeObjectPage.selectObjectChildrenPath(
        `/storage/${parentObjectSchemeIdentifier}/${parentObjectUniqId}`,
        {
          schemeName: objectSchemeIdentifier,
          objectUniqId: uniqId,
        }
      )
    } else if (objectSchemeIdentifier && uniqId) {
      setPathQuery(`/storage/${objectSchemeIdentifier}/${uniqId}`, {})
    }
  }

  return (
    <Stack
      direction="row"
      spacing={3}
      alignItems="center"
      justifyContent="space-between"
      px={4}
      py={5}
      pr={12}
      width={370}
      sx={{
        position: 'relative',
        borderRadius: '12px',
        background: '#030426',
        boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.12)',
      }}
    >
      <Stack direction="row" spacing={3} alignItems="center">
        <Avatar src={activeCall?.subscriber?.storageObject?.icon}></Avatar>
        <Stack spacing={1}>
          <Stack>
            <Typography
              variant="subtitle2"
              fontWeight={'bolder'}
              color={'white'}
            >
              {activeCall?.subscriber?.storageObject?.primary || 'Unknown'}
            </Typography>
            {/* <Typography>Samsung</Typography> */}
          </Stack>
          <Stack>
            <Typography variant="caption" color={'grey.500'}>
              {activeCall?.subscriber?.identifier || 'Unknown'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack>
        {activeCall?.subscriber?.storageObject && (
          <Button
            variant="outlined"
            size="small"
            sx={{ px: 2, py: 2, fontWeight: 400 }}
            onClick={handleOpenDetails}
          >
            Open details
          </Button>
        )}
        <IconButton
          size="small"
          color="error"
          onClick={() => setActiveCallsClose({ id: activeCall.id })}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
          }}
        >
          <UserIcon
            icon="material-symbols-light:cancel-outline"
            fontSize={22}
          />
        </IconButton>
      </Stack>
    </Stack>
  )
}
